import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Col, Row } from 'reactstrap'
import { withNamespaces } from 'react-i18next'
import styled from 'styled-components'

import CreateTicketModal from './CreateTicketModal'
import { selectActiveState } from '../../ducks/states'
import { toggleModal } from '../../ducks/createInteraction'

import MobilePropertySelect from '../MobilePropertySelect'
import Button from '../../components/Forms/Button'

const StyledButtonText = styled.div`
  text-transform: uppercase;
  letter-spacing: 1.12px;
  display: flex;
  align-items: center;
`

const StyledBadge = styled.div`
  background-color: rgba(218, 105, 46, 0.2);
  border-radius: 40%;
  color: #da692e;
  font-size: 11px;
  text-align: center;
  margin-left: 13px;
  padding: 3px 10px;
`

const renderButtons = ({ states, selectActiveState, t }) => {
  const { entities, selectedState, loading, onlyRequiredAction } = states

  // TODO refactor it
  const opened = entities[0]
  const awaiting = entities[1]
  const closed = entities[2]
  const feedback = entities[3]

  if (onlyRequiredAction) {
    return (
      <React.Fragment>
        <Col
          md={{
            size: 4,
            order: 0
          }}
          xs={{
            order: 1
          }}
        >
          <Button
            active={awaiting.type === selectedState}
            onClick={() => selectActiveState(1, true)}
            outline
            bgColor="#fff"
            disabled={loading}
          >
            <StyledButtonText>
              {t(`states:${awaiting.type}`)} ({awaiting.count})
            </StyledButtonText>
          </Button>
        </Col>
        <Col
          md={{
            size: 4,
            order: 1
          }}
          xs={{
            order: 2
          }}
        >
          <Button
            active={feedback.type === selectedState}
            onClick={() => selectActiveState(3, true)}
            outline
            bgColor="#fff"
            disabled={loading}
          >
            <StyledButtonText>
              {t(`states:${feedback.type}`)} ({feedback.count})
            </StyledButtonText>
          </Button>
        </Col>
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <Col
        md={{
          size: 4,
          order: 0
        }}
        xs={{
          order: 1
        }}
      >
        <Button
          active={opened.type === selectedState}
          onClick={() => selectActiveState(0, false)}
          outline
          bgColor="#fff"
          disabled={loading}
        >
          <StyledButtonText>
            {t(`states:${opened.type}`)} ({opened.count}){' '}
            <StyledBadge>{awaiting.count}</StyledBadge>
          </StyledButtonText>
        </Button>
      </Col>
      <Col
        md={{
          size: 4,
          order: 1
        }}
        xs={{
          order: 2
        }}
      >
        <Button
          active={closed.type === selectedState}
          onClick={() => selectActiveState(2, false)}
          outline
          bgColor="#fff"
          disabled={loading}
        >
          <StyledButtonText>
            {t(`states:${closed.type}`)} ({closed.count}){' '}
            <StyledBadge>{feedback.count}</StyledBadge>
          </StyledButtonText>
        </Button>
      </Col>
    </React.Fragment>
  )
}

const States = ({ states, selectActiveState, t, toggleModal }) => {
  return (
    <React.Fragment>
      <Row>
        <Col xs={12} className="d-md-none">
          <MobilePropertySelect />
        </Col>
      </Row>
      <Row>
        {renderButtons({ states, selectActiveState, t, toggleModal })}
        <Col
          md={{
            size: 4,
            order: 2
          }}
          xs={{
            order: 0
          }}
        >
          <CreateTicketModal />
          <Button onClick={toggleModal}>{t('tickets:createNew')}</Button>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default compose(
  connect(
    ({ states }) => ({
      states
    }),
    {
      selectActiveState,
      toggleModal
    }
  ),
  withNamespaces()
)(States)
